export enum PaymentMethod {
    PaymentAtLocation,
    BankTransfer,
    PayPal,
    RedsysCreditCard,
    RedsysBizum,
    PersonalBizum,
    PaymentAtHandingOver,
}
